import Graphic from '@arcgis/core/Graphic';

/**
 * Create an instance of the Polygon and returns it
 * @param {Object} mapObject - map object
 * @param {Object} configs
 * @param {Object} configs.geometry - the Geometry
 * @param {Url} configs.symbol - the Symbol
 *
 */
export const createPolylineGeometry = async ({ mapObject, configs }) =>
  await handlePolylineGeometry({ configs });

const handlePolylineGeometry = ({ configs }) => {
  // The geometry.type: 'polyline' and symbol.type: 'simple-line'  will autocast
  // the polyline and simpleLineSymbol when created
  const polyline = new Graphic({
    ...configs,
  });
  return { polyline };
};
